export default "__VITE_ASSET__BYq0TMw5__"